// src/components/OptionsScreen.ts
import { store } from '../app/state.js';

export function OptionsScreen(opts: { onBack: () => void }): HTMLElement {
  const el = document.createElement('div');
  el.className = 'panel';
  const o = store.getOptions();

  el.innerHTML = `
    <div class="panel__head">
      <div class="kicker">Configuración</div>
      <div class="h1" style="font-size:clamp(1.6rem,5vw,2rem)"><span>Opciones</span></div>
      <p class="subtitle">Ajustes de Fase 1. Se guardan localmente y se sincronizarán con tu perfil en D1.</p>
    </div>
    <div class="panel__body" style="display:grid;gap:.9rem">
      <div class="field">
        <div class="field__label">Volumen general · <span data-role="master-val">${Math.round(o.masterVolume * 100)}%</span></div>
        <input class="range" data-role="master" type="range" min="0" max="100" value="${Math.round(o.masterVolume * 100)}" />
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:.7rem">
        <div class="field">
          <div class="field__label">Música · <span data-role="music-val">${Math.round(o.musicVolume * 100)}%</span></div>
          <input class="range" data-role="music" type="range" min="0" max="100" value="${Math.round(o.musicVolume * 100)}" />
        </div>
        <div class="field">
          <div class="field__label">Efectos · <span data-role="sfx-val">${Math.round(o.sfxVolume * 100)}%</span></div>
          <input class="range" data-role="sfx" type="range" min="0" max="100" value="${Math.round(o.sfxVolume * 100)}" />
        </div>
      </div>

      <div class="toggle-row">
        <div>
          <div class="toggle-row__label">Movimiento reducido</div>
          <div class="toggle-row__hint">Desactiva animaciones intensas</div>
        </div>
        <button class="switch" role="switch" aria-checked="${o.reducedMotion ? 'true' : 'false'}" data-role="reduced" type="button" aria-label="Movimiento reducido">
          <span class="switch__thumb"></span>
        </button>
      </div>

      <div class="field">
        <div class="field__label">Velocidad de texto</div>
        <div style="display:flex;gap:.5rem">
          ${(['lenta', 'normal', 'rapida'] as const)
            .map(
              (v) =>
                `<button class="btn ${o.textSpeed === v ? 'btn--ghost' : 'btn--subtle'}" data-speed="${v}" type="button" style="padding:.6rem .7rem;font-size:.74rem">${v}</button>`
            )
            .join('')}
        </div>
      </div>

      <div class="divider"></div>

      <div class="notice">
        <strong>Cloudflare:</strong> las opciones se guardan en <code style="font-family:var(--font-mono);background:rgba(255,255,255,.08);padding:.1rem .3rem;border-radius:6px">localStorage</code> como
        <code style="font-family:var(--font-mono);background:rgba(255,255,255,.08);padding:.1rem .3rem;border-radius:6px">aetheria:options:v1</code>.
        En producción se persistirán vía <code style="font-family:var(--font-mono);background:rgba(255,255,255,.08);padding:.1rem .3rem;border-radius:6px">/api/profile</code> + D1.
      </div>

      <div class="btn-row">
        <button class="btn btn--ghost" data-action="back" type="button">← Volver</button>
      </div>
    </div>
  `;

  const master = el.querySelector<HTMLInputElement>('[data-role="master"]')!;
  const music = el.querySelector<HTMLInputElement>('[data-role="music"]')!;
  const sfx = el.querySelector<HTMLInputElement>('[data-role="sfx"]')!;
  const masterVal = el.querySelector<HTMLSpanElement>('[data-role="master-val"]')!;
  const musicVal = el.querySelector<HTMLSpanElement>('[data-role="music-val"]')!;
  const sfxVal = el.querySelector<HTMLSpanElement>('[data-role="sfx-val"]')!;

  master.addEventListener('input', () => {
    const v = Number(master.value) / 100;
    store.updateOptions({ masterVolume: v });
    masterVal.textContent = `${master.value}%`;
  });
  music.addEventListener('input', () => {
    const v = Number(music.value) / 100;
    store.updateOptions({ musicVolume: v });
    musicVal.textContent = `${music.value}%`;
  });
  sfx.addEventListener('input', () => {
    const v = Number(sfx.value) / 100;
    store.updateOptions({ sfxVolume: v });
    sfxVal.textContent = `${sfx.value}%`;
  });

  const sw = el.querySelector<HTMLButtonElement>('[data-role="reduced"]')!;
  sw.addEventListener('click', () => {
    const next = sw.getAttribute('aria-checked') !== 'true';
    sw.setAttribute('aria-checked', String(next));
    store.updateOptions({ reducedMotion: next });
    if (next) document.documentElement.style.setProperty('--aetheria-reduced', '1');
  });

  el.querySelectorAll<HTMLButtonElement>('[data-speed]').forEach((b) => {
    b.addEventListener('click', () => {
      const v = b.dataset.speed as 'lenta' | 'normal' | 'rapida';
      store.updateOptions({ textSpeed: v });
      el.querySelectorAll<HTMLButtonElement>('[data-speed]').forEach((x) => {
        x.className = x.dataset.speed === v ? 'btn btn--ghost' : 'btn btn--subtle';
        x.style.cssText = 'padding:.6rem .7rem;font-size:.74rem';
      });
    });
  });

  el.querySelector<HTMLButtonElement>('[data-action="back"]')!.addEventListener('click', opts.onBack);

  return el;
}
